<div class="modal opened">
  <ng-container [ngSwitch]="step">
    <!-- TO REVIEW ng17 cases check updated due to strict comparison -->
    <ng-template [ngSwitchCase]="SIGANTURE_STEP_ONE">
      <div class="modal-signature-main s_01">
        <div class="modal-header">
          <h2>Signature required<br>Step 1/2</h2>
        </div>
        <ng-container [ngSwitch]="signatureType">
          <ng-template [ngSwitchCase]="SIGNATURE_TYPES_ENUM.CFR11_COMPLETE_EMAIL">
            <!-- email input -->
            <p class="txt">We need to verify your identity. Please introduce your email below.</p>
            <div class="box_item">
              <form [formGroup]="emailForm"  (keydown.enter)="onContinueStep()" >
                <label class="box-label" [hidden]="label == ''">{{label}}</label>
                <input [placeholder]="emailPlaceholder" formControlName="email" autocomplete="off" type="email" [(ngModel)]="input">
              </form>
            </div>
          </ng-template>
          <!-- password input -->
          <ng-template [ngSwitchCase]="SIGNATURE_TYPES_ENUM.CFR11_COMPLETE">
            <p class="txt">We need to verify your identity. Please introduce your password below.</p>
            <div class="box_item">
              <form (keydown.enter)="onContinueStep()">
                <label class="box-label" [hidden]="label == ''">{{label}}</label>
                <input [placeholder]="placeholder" autocomplete="off" type="password" [(ngModel)]="input" [ngModelOptions]="{standalone: true}">
              </form>
            </div>
          </ng-template>
        </ng-container>
        <fieldset class="two-buttons">
          <core-helpers-forms-button [type]="'grey'" [text]="secondButtonText" 
            (submit)="onSecondAction()"
          ></core-helpers-forms-button>
          <core-helpers-forms-button-white [disabled]="!isInputReady()" [text]="'Continue'"
            (submit)="onContinueStep()"></core-helpers-forms-button-white>
        </fieldset>
      </div>
    </ng-template>
    <ng-template [ngSwitchCase]="SIGANTURE_STEP_TWO">
      <div class="modal-signature-main s_02">
        <div class="modal-header">
          <h2>Signature required<br>Step 2/2</h2>
        </div>
        <div class="modal-success" *ngIf="pinRequestStatus == PIN_STATUS.RENEWED else firstpin">
            <p class="txt">
              <strong>We have sent a NEW 5-digit pin to your email.<br>Please enter the pin below.</strong>
            </p>
        </div>
        <ng-template #firstpin>
          <div class="loader-small" *ngIf="pinRequestStatus == PIN_STATUS.REQUESTED else defaultPinMessage">
            <core-helpers-box-loading ></core-helpers-box-loading>
          </div>
          <ng-template #defaultPinMessage>
            <p class="txt">We have sent a 5-digit pin to your email.<br> 
              <strong>Please enter the pin below.</strong>
            </p>
          </ng-template>
        </ng-template>
    
        <div class="box_item pin-signature">
          <form [formGroup]="form" (keydown.enter)="onAction()">
            <fieldset class="digital-sign">
              <div class="pin_list">
                <input #input1 type="text" maxlength="1" name="pin1" formControlName="pin1" [appAutoTab]="input2" />
                <input #input2 type="text" maxlength="1" name="pin2" formControlName="pin2" [appAutoTab]="input3" />
                <input #input3 type="text" maxlength="1" name="pin3" formControlName="pin3" [appAutoTab]="input4" />
                <input #input4 type="text" maxlength="1" name="pin4" formControlName="pin4" [appAutoTab]="input5"/>
                <input #input5 type="text" maxlength="1" name="pin5" formControlName="pin5"/>
              </div>
            </fieldset>
          </form>
          <span title="Send me a new pin" class="linked" (click)="requestNewPin()">Send me a new pin</span>
        </div>
         <fieldset class="two-buttons">
          <core-helpers-forms-button [type]="'grey'" [text]="secondButtonText" 
            (submit)="onStepBack()"
          ></core-helpers-forms-button>
          <core-helpers-forms-button-white [disabled]="!isPinValid() || disabled" [text]="'Sign'"
            (submit)="onAction()"></core-helpers-forms-button-white>
        </fieldset>
      </div>
    </ng-template>
  </ng-container>

</div>